<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>
    <!-- Left Col -->
    <!-- <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
        <DarkToggler class="d-none d-lg-block"/>
    </div> -->
    <b-navbar-nav class="nav align-items-center ml-auto">
        <Locale></Locale>
        <DarkToggler class="d-none d-lg-block"/>
        <UserDropdown></UserDropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import DarkToggler from './DarkToggler'
import Locale from './Locale'
import UserDropdown from './UserDropdown'

export default {
    components: {
        DarkToggler,
        Locale,
        UserDropdown
    },
    props: {
        toggleVerticalMenuActive: {
            type: Function,
            default: () => {}
        }
    }
}
</script>
